import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

export function formatDate(dateString) {
  const date = new Date(dateString);
  return date.toLocaleDateString('pt-PT', {
    day: 'numeric',
    month: 'long',
    year: 'numeric'
  });
}

export function formatDateShort(dateString) {
  const date = new Date(dateString);
  return date.toLocaleDateString('pt-PT', {
    day: 'numeric',
    month: 'short',
    year: 'numeric'
  });
}

export function formatPrice(price, currency = 'EUR') {
  return new Intl.NumberFormat('pt-PT', {
    style: 'currency',
    currency: currency
  }).format(price);
}

export function truncateText(text, maxLength) {
  if (text.length <= maxLength) return text;
  return text.substring(0, maxLength).trim() + '...';
}

export function getCategoryColor(category) {
  const colors = {
    'Vistos': 'bg-[#0F5A34]',
    'AIMA': 'bg-[#E53935]',
    'Cidadania': 'bg-[#0F5A34]',
    'Custo de Vida': 'bg-[#DFAF3A] text-[#1A1A1A]',
    'Moradia': 'bg-[#0F5A34]',
    'Cidades': 'bg-[#0F5A34]',
    'Saúde': 'bg-[#E53935]',
    'Trabalho': 'bg-[#0F5A34]',
    'Empreendedorismo': 'bg-[#DFAF3A] text-[#1A1A1A]',
    'Notícias': 'bg-[#0F5A34]',
    'Curiosidades': 'bg-[#DFAF3A] text-[#1A1A1A]',
    // legacy fallback
    'Imigração': 'bg-[#0F5A34]',
  };
  return colors[category] || 'bg-[#0F5A34]';
}

export function resolveImageUrl(url) {
  if (!url) return '';
  if (url.startsWith('http://') || url.startsWith('https://') || url.startsWith('data:') || url.startsWith('blob:')) return url;
  if (url.startsWith('/api/')) return `${process.env.REACT_APP_BACKEND_URL}${url}`;
  return url;
}
